import { render, staticRenderFns } from "./SignRecord.vue?vue&type=template&id=65b8fb32&scoped=true&"
import script from "./SignRecord.vue?vue&type=script&lang=js&"
export * from "./SignRecord.vue?vue&type=script&lang=js&"
import style0 from "./SignRecord.vue?vue&type=style&index=0&id=65b8fb32&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8fb32",
  null
  
)

export default component.exports